(function () {
  'use strict';

  var CFG = {
    keratina: { start: 10, min: 3, lsKey: 'kc_s_ker4' },
    cirugia:  { start: 15, min: 4, lsKey: 'kc_s_cir5' }
  };

  function readStock(cfg) {
    try {
      var v = localStorage.getItem(cfg.lsKey);
      if (v === null) return cfg.start;
      var n = parseInt(v, 10);
      return isNaN(n) ? cfg.start : Math.max(cfg.min, Math.min(cfg.start, n));
    } catch (e) { return cfg.start; }
  }

  function writeStock(cfg, val) {
    try { localStorage.setItem(cfg.lsKey, val); } catch (e) {}
  }

  function updateDOM(treatment, value) {
    document.querySelectorAll('.kc-stock-num[data-stock="' + treatment + '"]').forEach(function (el) {
      el.textContent = value;
    });
  }

  function decrement(treatment) {
    var cfg = CFG[treatment];
    var cur = readStock(cfg);
    if (cur > cfg.min) {
      cur--;
      writeStock(cfg, cur);
    }
    updateDOM(treatment, cur);
  }

  function init() {
    /* Mostrar valor actual al cargar */
    Object.keys(CFG).forEach(function (t) {
      updateDOM(t, readStock(CFG[t]));
    });

    /* Cuenta regresiva: -1 cada 60 segundos */
    setInterval(function () {
      Object.keys(CFG).forEach(function (t) { decrement(t); });
    }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
